import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-dlg-select-option',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './dlg-select-option.component.html',
  styleUrls: ['./dlg-select-option.component.css'],
})
export class DlgSelectOptionComponent {
  readonly dialogRef = inject(MatDialogRef<DlgSelectOptionComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  title: string;
  description: string = 'Select an option to proceed';
  multiple: boolean = false;
  action: string = 'Ok';
  options: string[];
  selectedOption: string[];

  constructor() {
    this.title = this.data.title;
    this.description = this.data.description;
    this.action = this.data.action;
    this.multiple = this.data.multiple ?? false;
    this.options = this.data.options;
    this.selectedOption = Object.assign([], this.data.selectedOption);
  }

  onChangeOption(event: any): void {
    if (this.selectedOption.includes(event.target.value)) {
      this.selectedOption = this.selectedOption.filter(
        (option) => option !== event.target.value
      );
    } else {
      this.selectedOption.push(event.target.value);
    }
  }

  onTextSelection(value: string) {
    if (this.selectedOption.includes(value)) {
      this.selectedOption = this.selectedOption.filter(
        (option) => option !== value
      );
    } else {
      this.selectedOption.push(value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    this.dialogRef.close(this.selectedOption);
  }
}
